import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { DisplayType } from "models/enums/style";
import { IconDefinitionConstants } from "utils/constants";
import { WidgetBaseProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { ButtonBase, Grid } from "@mui/material";
import { ViewPanel, ActionLinkButton, Icon } from "components/common";
import { useNewService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const News: React.FC<WidgetBaseProps> = (props) => {
  const newsService = useNewService();
  const [news, setNews] = React.useState<WintSuperkollAPIModel.NewsArticle>();

  React.useEffect(() => {
    props.onVisibilityChange && props.onVisibilityChange(news === undefined);
  }, [news]);

  React.useEffect(() => {
    newsService.getLatestArticle().then((res) => {
      if (res) {
        setNews(res);
      }
    });
  }, []);

  const gotoNewsLink = (link?: string) => {
    window.open(link, "_blank");
  };

  return news ? (
    <ViewPanel appearance="sm" className={cssExports.newsContainer}>
      <ButtonBase component="div" onClick={gotoNewsLink.bind(null, news.link)}>
        <Grid container direction="column" className={cssExports.newsItem}>
          <Grid item className={cssExports.newsTitle}>
            {news.name}
          </Grid>
          <Grid item className={cssExports.newsContent}>
            {news.content?.substring(0, 100) + "..."}
          </Grid>
          <Grid item sm className={cssExports.publishDate}>
            {LocalizationHelperInstance.getFormattedDate(news.publishedDate)}
          </Grid>
        </Grid>
      </ButtonBase>
      <Grid item className={cssExports.newsFooter}>
        <ActionLinkButton
          className={clsx(cssExports.seeMoreLink, cssExports.animatedLink)}
          onClick={gotoNewsLink.bind(null, "https://faq-v2.wint.se/nyheter")}
          endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} displayType={DisplayType.Info} />}
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AllNews)}
        </ActionLinkButton>
      </Grid>
    </ViewPanel>
  ) : null;
};

export default News;
